export const forgotPasswordCode = () => {
  return {
    title: 'ACTUALIZAR CONTRASEÑA',
    subtitle_1: 'Porfavor actualice su contraseña.',
    code: 'Código',
    new_password: 'Ingrese Nueva Contraseña',
    re_enter_new_password: 'Ingrese nuevamente la nueva contraseña',
    reset_password: 'Iniciar Sesión',
    mobile_title: 'Usuario Móbil',
    mobile_message: 'Su contraseña ha sido actualizada, por favor inicie sesión en la aplicación FieldTech Connect.',
    back_to_login: 'Volver al inicio'
  }
}
